import React from "react";
import PropertiesList from "./PropertiesList";

function PropertiesAdd() {
  return <PropertiesList />;
}

export default PropertiesAdd;
